<template>
  <v-dialog
    v-model="dialogVisible"
    persistent
    :max-width="$attrs['max-width'] || 600"
    v-bind="$attrs"
    v-on="$listeners"
    @keydown.esc="$emit('on-close')"
  >
    <slot name="activator"></slot>
    <template #default>
      <v-card>
        <v-card-title class="dialog-card-title">
          <h2 class="subtitle-1">
            {{ title }}
          </h2>
        </v-card-title>
        <v-card-text class="content overflow-auto">
          <slot name="content"></slot>
        </v-card-text>
        <v-divider v-if="$slots['footer']" />
        <v-card-actions class="dialog-card-footer">
          <v-spacer></v-spacer>
          <slot name="footer"></slot>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  name: 'uiDialog',
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 800;
}
.content {
  min-height: 10.5vh;
  max-height: 68vh;
}
.v-dialog > .v-card > .v-card__text {
  padding: 2rem;
}

.dialog-card-title {
  background-image: url('../../assets/mc_template.png');
  background-size: cover;
  background-position: center;
}

.dialog-card-footer {
  background-image: url('../../assets/mc_template.png');
  background-size: cover;
  background-position: center;
}
</style>
